<template>
  <div class="bo-wrapper" :class="computer ? 'bo-wrapper-pc' : ''" @click="handlePageClick">
    <header class="ant-layout-header">
      <div class="left">
        BOBO公式
      </div>

      <div class="right">
        <div class="select" data-select="1" @click="showSelectList = !showSelectList">
          <div data-select="1">{{ renderSelectMode }}</div>
          <div data-select="1" class="select-icon"></div>
        </div>
        <div data-select="1" class="select-list" :class="{ 'show': showSelectList }">
          <div data-select="1" @click="handleSelectMode('1')" :class="{ 'active': selectMode === '1' }">公式一(常规眼)
          </div>
          <div data-select="1" @click="handleSelectMode('2')" :class="{ 'active': selectMode === '2' }">公式二(屈光术后)
          </div>
          <div data-select="1" @click="handleSelectMode('3')" :class="{ 'active': selectMode === '3' }">公式三(散光人工晶体)
          </div>
        </div>
      </div>

    </header>
    <a-layout-content style="padding: 0 20px">
      <div v-if="selectMode === '3'" class="toric-page">
        <div class="toric-heading">
          <div>
            <h2>散光人工晶体度数计算器</h2>
            
            <p>双角度矢量法 · 近轴光学转换 · Baylor 后表面散光预测 <em>注：对话框里面均需要填入对应数值</em></p>
          </div>
          <span>仅供临床参考</span>
        </div>

        <div class="toric-patient">
          <label>患者 <a-input v-model:value="formState.name" placeholder="姓名" /></label>
          <label>病历号 <a-input v-model:value="formState.id" placeholder="ID" /></label>
          <label>术眼
            <a-select v-model:value="toricEye"><a-select-option value="OD">右眼</a-select-option><a-select-option value="OS">左眼</a-select-option></a-select>
          </label>
          <label>IOL等效球镜 <a-input v-model:value="activeToric.sphere" class="important-input" suffix="D" /></label>
        </div>

        <div class="toric-input-grid">
          <div class="toric-card">
            <div class="card-title aca-title">
              <div>角膜前表面 <span class="title-badge">ACA / K值</span></div>
              <a-checkbox v-model:checked="activeToric.totalCorneal">全角膜散光模式</a-checkbox>
            </div>
            <div class="toric-row">
              <label>K1</label><div class="toric-number-field"><a-input-number v-model:value="activeToric.k1" :min="0" :max="100" :step="0.01" /><span>D</span></div>
              <label>轴位</label><div class="toric-number-field"><a-input-number v-model:value="activeToric.k1Axis" :min="0" :max="180" :step="1" /><span>°</span></div>
            </div>
            <div class="toric-row">
              <label>K2</label><div class="toric-number-field"><a-input-number v-model:value="activeToric.k2" :min="0" :max="100" :step="0.01" /><span>D</span></div>
              <label>轴位</label><div class="toric-number-field"><a-input-number v-model:value="activeToric.k2Axis" :min="0" :max="180" :step="1" /><span>°</span></div>
            </div>

            <div class="toric-result-line"><strong>ACA</strong>{{ formatToric(toricResult.acaCyl, toricResult.acaAxis) }}</div>
          </div>

          <div class="toric-card pca-card">
            <div class="card-title">角膜后表面散光 <span class="title-badge">PCA / Baylor</span></div>
            <div class="toric-hint">WTR阈值 1.7D · ATR阈值 0.4D · 基于 ACA 自动计算</div>
            <div class="pca-box">
              <div>{{ baylorDescription }}</div>
              <strong>{{ pcaDescription }}</strong>
            </div>
          </div>

          <div class="toric-card combined-card">
            <div class="combined-section">
              <div class="card-title">手术诱导散光 <span class="title-badge">SIA</span></div>
              <div class="toric-row">
                <label>度数</label><div class="toric-number-field"><a-input-number v-model:value="activeToric.siaCyl" :min="0" :step="0.01" /><span>D</span></div>
                <label>轴位</label><div class="toric-number-field"><a-input-number v-model:value="activeToric.siaAxis" :min="0" :max="180" :step="1" /><span>°</span></div>
              </div>
            </div>
            <div class="combined-section optical-card">
              <div class="card-title">光学参数</div>
              <div class="optical-inputs">
                <label><span>K_avg</span><div class="toric-number-field"><a-input-number :value="toricKAvg" disabled /><span>D</span></div></label>
                <label><span>角膜-IOL距</span><div class="toric-number-field"><a-input-number v-model:value="activeToric.iolDist" :min="0" :step="0.1" /><span>mm</span></div></label>
              </div>
            </div>
          </div>
        </div>

        <div class="toric-analysis">
          <div class="analysis-title">选定 Toric IOL · 残留分析 <span>轴位自动对齐</span></div>
          <div class="iol-summary">
            <label>IOL度数 <a-input v-model:value="activeToric.iolCyl" class="important-input" suffix="D" /></label>
            <label>IOL平面所需 <a-input :value="formatToric(toricResult.iolNeededCyl, toricResult.iolNeededAxis)" disabled /></label>
            <div class="axis-thumb">
              <div class="axis-circle">
                <i :style="axisLineStyle"></i><b>T</b>
                <span class="axis-degree axis-degree-top">0°</span>
                <span class="axis-degree axis-degree-current">{{ formatAxis(toricResult.iolNeededAxis) }}</span>
                <span class="axis-degree axis-degree-left">90°</span>
                <span class="axis-degree axis-degree-right">90°</span>
                <span class="axis-degree axis-degree-bottom">180°</span>
              </div>
              <div>目标 <strong>{{ formatAxis(toricResult.targetAxis) }}</strong><br />植入 <strong>{{ formatAxis(toricResult.iolNeededAxis) }}</strong></div>
            </div>
          </div>
          <div class="residual-grid">
            <div><span>选定 IOL</span><strong>{{ selectedIolText }}</strong></div>
            <div><span>残留散光 (IOL平面)</span><strong class="danger">{{ formatResidualToric(toricResult.residualCyl, toricResult.residualAxis) }}</strong></div>
            <div><span>残留散光 (角膜平面)</span><strong class="danger">{{ formatResidualToric(toricResult.residualCorneaCyl, toricResult.residualCorneaAxis) }}</strong></div>
          </div>
          <div class="rotation-title">旋转影响评估 (IOL平面)</div>
          <a-table class="rotation-table" :columns="toricColumns" :data-source="rotationRows" :pagination="false" size="small" row-key="rotationDeg" />
        </div>

        <div v-if="toricError" class="toric-error">计算异常：{{ toricError }}</div>
        <div class="toric-actions">
          <a-button @click="handleResetData">重置(reset)</a-button>
        </div>
      </div>

      <a-form v-else class="custom-form" ref="formRef" :model="formState" :rules="rules"
        :label-col="{ style: { width: computer ? '1.04rem' : '150px' } }"
        :wrapper-col="{ style: { width: computer ? '1.50rem' : '250px' } }" layout="inline" labelAlign="left"
        :colon="false">
        <div class="user-info" v-if="computer">
          <div>
            患者姓名(Name):
            <a-input v-model:value="formState.name" placeholder="患者姓名(Name)" />
          </div>
          <div>
            患者年龄(Age):
            <a-input v-model:value="formState.age" placeholder="患者年龄(Age)" />
          </div>
          <div>
            患者ID:
            <a-input v-model:value="formState.id" placeholder="患者ID" />
          </div>
          <div>
            医生(Surgeon):
            <a-input v-model:value="formState.Surgeon" placeholder="医生(Surgeon)" />
          </div>
        </div>

        <a-divider v-if="computer"></a-divider>

        <div class="params-wrapper">
          <div class="params-space">
            <div class="eye" v-if="computer">右眼 <span>(OD)</span></div>
            <a-divider orientation="left" v-else>右眼(OD)</a-divider>
            <template v-if="selectMode !== '3'">
              <a-form-item label="屈光指数(Index)" required>
                <a-input v-model:value="formState.refractiveIndex" disabled />
              </a-form-item>
              <a-form-item label="眼轴长(L)" name="odal"><a-input v-model:value="formState.odal" placeholder="光学眼轴长" suffix="mm" /></a-form-item>
              <a-form-item label="K值(K1)" name="odk1"><a-input v-model:value="formState.odk1" placeholder="SimK" suffix="D" /></a-form-item>
              <a-form-item label="K值(K2)" name="odk2"><a-input v-model:value="formState.odk2" placeholder="SimK" suffix="D" /></a-form-item>
              <a-form-item label="前房深度(ACD)" name="odacd"><a-input v-model:value="formState.odacd" placeholder="include CCT" suffix="mm" /></a-form-item>
              <a-form-item label="目标屈光度(Target)" name="odtarget"><a-input v-model:value="formState.odtarget" placeholder="目标屈光度(Target)" suffix="D" /></a-form-item>
              <a-form-item label="A常数(A constant)" name="odaConstant"><a-input v-model:value="formState.odaConstant" placeholder="优化后的光学A常数" /></a-form-item>
              <a-form-item label="晶体厚度(LT)"><a-input v-model:value="formState.odlt" suffix="mm" /></a-form-item>
              <a-form-item label="角膜厚度(CCT)"><a-input v-model:value="formState.odcct" suffix="um" /></a-form-item>
              <a-form-item label="角膜直径(WTW)"><a-input v-model:value="formState.odwtw" suffix="mm" /></a-form-item>
            </template>
            <template v-else>
              <a-form-item label="K值(K1)" name="odk1"><a-input v-model:value="formState.odk1" suffix="D" /></a-form-item>
              <a-form-item label="K1轴位" name="odk1Axis"><a-input v-model:value="formState.odk1Axis" suffix="°" /></a-form-item>
              <a-form-item label="K值(K2)" name="odk2"><a-input v-model:value="formState.odk2" suffix="D" /></a-form-item>
              <a-form-item label="K2轴位" name="odk2Axis"><a-input v-model:value="formState.odk2Axis" suffix="°" /></a-form-item>
              <a-form-item label="手术诱导散光(SIA)" name="odsiaCyl"><a-input v-model:value="formState.odsiaCyl" suffix="D" /></a-form-item>
              <a-form-item label="SIA轴位" name="odsiaAxis"><a-input v-model:value="formState.odsiaAxis" suffix="°" /></a-form-item>
              <a-form-item label="角膜-IOL距" name="odiolDist"><a-input v-model:value="formState.odiolDist" suffix="mm" /></a-form-item>
              <a-form-item label="IOL散光度数" name="odiolCyl"><a-input v-model:value="formState.odiolCyl" suffix="D" /></a-form-item>
              <a-form-item label="IOL等效球镜"><a-input v-model:value="formState.odiolSphere" suffix="D" /></a-form-item>
              <a-form-item label="全角膜散光模式"><a-checkbox v-model:checked="formState.odtotalCorneal">启用</a-checkbox></a-form-item>
            </template>
          </div>

          <div>
            <div class="eye" v-if="computer">左眼 <span>(OS)</span></div>
            <a-divider orientation="left" v-else>左眼(OS)</a-divider>
            <template v-if="selectMode !== '3'">
              <a-form-item label="屈光指数(Index)" required><a-input v-model:value="formState.refractiveIndex" disabled /></a-form-item>
              <a-form-item label="眼轴长(L)" name="osal"><a-input v-model:value="formState.osal" placeholder="光学眼轴长" suffix="mm" /></a-form-item>
              <a-form-item label="K值(K1)" name="osk1"><a-input v-model:value="formState.osk1" placeholder="SimK" suffix="D" /></a-form-item>
              <a-form-item label="K值(K2)" name="osk2"><a-input v-model:value="formState.osk2" placeholder="SimK" suffix="D" /></a-form-item>
              <a-form-item label="前房深度(ACD)" name="osacd"><a-input v-model:value="formState.osacd" placeholder="include CCT" suffix="mm" /></a-form-item>
              <a-form-item label="目标屈光度(Target)" name="ostarget"><a-input v-model:value="formState.ostarget" placeholder="目标屈光度(Target)" suffix="D" /></a-form-item>
              <a-form-item label="A常数(A constant)" name="osaConstant"><a-input v-model:value="formState.osaConstant" placeholder="优化后的光学A常数" /></a-form-item>
              <a-form-item label="晶体厚度(LT)"><a-input v-model:value="formState.oslt" suffix="mm" /></a-form-item>
              <a-form-item label="角膜厚度(CCT)"><a-input v-model:value="formState.oscct" suffix="um" /></a-form-item>
              <a-form-item label="角膜直径(WTW)"><a-input v-model:value="formState.oswtw" suffix="mm" /></a-form-item>
            </template>
            <template v-else>
              <a-form-item label="K值(K1)" name="osk1"><a-input v-model:value="formState.osk1" suffix="D" /></a-form-item>
              <a-form-item label="K1轴位" name="osk1Axis"><a-input v-model:value="formState.osk1Axis" suffix="°" /></a-form-item>
              <a-form-item label="K值(K2)" name="osk2"><a-input v-model:value="formState.osk2" suffix="D" /></a-form-item>
              <a-form-item label="K2轴位" name="osk2Axis"><a-input v-model:value="formState.osk2Axis" suffix="°" /></a-form-item>
              <a-form-item label="手术诱导散光(SIA)" name="ossiaCyl"><a-input v-model:value="formState.ossiaCyl" suffix="D" /></a-form-item>
              <a-form-item label="SIA轴位" name="ossiaAxis"><a-input v-model:value="formState.ossiaAxis" suffix="°" /></a-form-item>
              <a-form-item label="角膜-IOL距" name="osiolDist"><a-input v-model:value="formState.osiolDist" suffix="mm" /></a-form-item>
              <a-form-item label="IOL散光度数" name="osiolCyl"><a-input v-model:value="formState.osiolCyl" suffix="D" /></a-form-item>
              <a-form-item label="IOL等效球镜"><a-input v-model:value="formState.osiolSphere" suffix="D" /></a-form-item>
              <a-form-item label="全角膜散光模式"><a-checkbox v-model:checked="formState.ostotalCorneal">启用</a-checkbox></a-form-item>
            </template>
          </div>
        </div>

        <a-divider> </a-divider>
        <div v-if="computer" class="note">
          <a-form-item label=" " :wrapper-col="{ span: 24 }">
            <span> {{ modeText }} </span>
          </a-form-item>

          <div style="display: flex; justify-content: center; width: 100%">
            <a-space>
              <a-button type="primary" @click="handleCalculate">计算(count)</a-button>
              <a-button type="primary" @click="handleResetData"> 重置(reset) </a-button></a-space>
          </div>
        </div>
        <div v-else>
          <a-form-item label=" " :wrapper-col="{ span: 24 }">
            <span> {{ modeText }} </span>
            <a-button type="primary" @click="handleCalculate" style="margin-top: 10px">开始计算</a-button>
          </a-form-item>
        </div>
      </a-form>
    </a-layout-content>
  </div>
</template>

<script setup>
import { Toast, isComputer } from "@/utils";
import { reactive, ref, watch, computed, h } from "vue";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

const modeText = computed(() => {
  if (selectMode.value === "1") {
    return "(此公式不适用于角膜屈光手术后的IOL计算)";
  }
  if (selectMode.value === "2") {
    return "不适用于RK术后 Don't for Post RK Surgery";
  }
  return "散光人工晶体度数计算 · 仅供临床参考";
});

const renderSelectMode = computed(() => {
  if (selectMode.value === "1") {
    return "公式一(常规眼)";
  }
  if (selectMode.value === "2") {
    return "公式二(屈光术后)";
  }
  return "公式三(散光人工晶体)";
});

const computer = isComputer();

const selectMode = ref("1");
const showSelectList = ref(false);
const toricEye = ref("OD");
const toricLoading = ref(false);
const toricError = ref("");
const toricResult = reactive({});

const createToricState = () => reactive({
  k1: "42.00",
  k1Axis: "180",
  k2: "44.00",
  k2Axis: "90",
  siaCyl: "0.40",
  siaAxis: "180",
  iolDist: "4.0",
  iolCyl: "3.00",
  sphere: "-1.25",
  totalCorneal: false,
});
const odToric = createToricState();
const osToric = createToricState();
const activeToric = computed(() => toricEye.value === "OD" ? odToric : osToric);
const toricKAvg = computed(() => {
  const value = (Number(activeToric.value.k1) + Number(activeToric.value.k2)) / 2;
  return Number.isFinite(value) ? value.toFixed(1) : "--";
});
const formatAxis = (axis) => Number.isFinite(Number(axis)) ? `${Number(axis).toFixed(0)}°` : "--";
const formatToric = (cyl, axis) => Number.isFinite(Number(cyl)) && Number.isFinite(Number(axis))
  ? `${Number(cyl).toFixed(2)} D @ ${Number(axis).toFixed(1)}°` : "--";
const formatResidualToric = (cyl, axis) => Number.isFinite(Number(cyl)) && Number.isFinite(Number(axis))
  ? `${Number(cyl).toFixed(2)} D @ ${Number(axis).toFixed(1)} deg` : "--";
const normalizeAxis = (axis) => ((axis % 180) + 180) % 180;
const vectorAdd = (c1, a1, c2, a2) => {
  const x = c1 * Math.cos(2 * a1 * Math.PI / 180) + c2 * Math.cos(2 * a2 * Math.PI / 180);
  const y = c1 * Math.sin(2 * a1 * Math.PI / 180) + c2 * Math.sin(2 * a2 * Math.PI / 180);
  const cyl = Math.sqrt(x * x + y * y);
  return { cyl, axis: cyl < 0.0001 ? 0 : normalizeAxis(Math.atan2(y, x) * 90 / Math.PI) };
};
const getAcaType = (axis) => {
  const value = normalizeAxis(Number(axis));
  if (Math.abs(value - 90) <= 30) return "WTR";
  if (Math.min(value, 180 - value) <= 30) return "ATR";
  return "Oblique";
};
const baylorDescription = computed(() => {
  if (!Number.isFinite(Number(toricResult.acaCyl))) return "--";
  if (activeToric.value.totalCorneal) return "全角膜散光模式：后表面散光设为0";
  const target = vectorAdd(Number(toricResult.acaCyl), Number(toricResult.acaAxis), Number(toricResult.pcaCyl), Number(toricResult.pcaAxis));
  return `Baylor目标矫正：${formatToric(target.cyl, target.axis)} (ACA ${getAcaType(toricResult.acaAxis)} ${Number(toricResult.acaCyl).toFixed(2)}D)`;
});
const pcaDescription = computed(() => {
  if (!Number.isFinite(Number(toricResult.pcaCyl))) return "--";
  if (activeToric.value.totalCorneal) return "PCA = 0.00 D";
  return Number(toricResult.pcaCyl) > 0.001 ? `等效PCA：${formatToric(toricResult.pcaCyl, toricResult.pcaAxis)}` : "无需植入Toric IOL";
});
const selectedIolText = computed(() => Number.isFinite(Number(toricResult.iolNeededAxis))
  ? formatToric(activeToric.value.iolCyl, toricResult.iolNeededAxis) : "--");
const axisLineStyle = computed(() => ({ transform: `rotate(${-Number(toricResult.iolNeededAxis || 0)}deg)` }));
const rotationRows = computed(() => {
  if (!Number.isFinite(Number(toricResult.iolNeededCyl))) return [];
  if (Array.isArray(toricResult.rotationImpacts)) return toricResult.rotationImpacts;
  return [0, 5, 10, 15, 20, 30, 45].map((rotationDeg) => {
    const effectiveRate = Math.cos(2 * rotationDeg * Math.PI / 180);
    const effectiveCyl = Number(activeToric.value.iolCyl) * effectiveRate;
    const residual = vectorAdd(Number(toricResult.iolNeededCyl), Number(toricResult.iolNeededAxis), -effectiveCyl, Number(toricResult.iolNeededAxis) + rotationDeg);
    return { rotationDeg, effectiveRate, residualCyl: residual.cyl, residualAxis: residual.axis };
  });
});
const getRotationLevel = (rotationDeg) => {
  const degree = Math.abs(Number(rotationDeg));
  if (degree === 0) return { text: "理想", type: "ideal" };
  if (degree <= 10) return { text: "轻微", type: "slight" };
  if (degree <= 15) return { text: "注意", type: "warning" };
  return { text: "严重", type: "severe" };
};
const toricColumns = [
  {
    title: "旋转角度",
    dataIndex: "rotationDeg",
    align: "center",
    customRender: ({ text }) => {
      const level = getRotationLevel(text);
      return h("span", { class: "rotation-angle" }, [
        `${text}° `,
        h("em", { class: `rotation-level rotation-${level.type}` }, level.text),
      ]);
    },
  },
  {
    title: "矫正率",
    dataIndex: "effectiveRate",
    align: "center",
    customRender: ({ text, record }) => {
      const level = getRotationLevel(record.rotationDeg);
      return h("strong", { class: `rotation-rate rotation-${level.type}` }, `${(Number(text) * 100).toFixed(1)}%`);
    },
  },
  { title: "残留散光", align: "center", customRender: ({ record }) => formatResidualToric(record.residualCyl, record.residualAxis) },
];

const handleToricCalculate = async () => {
  const source = activeToric.value;
  const keys = ["k1", "k1Axis", "k2", "k2Axis", "siaCyl", "siaAxis", "iolDist", "iolCyl"];
  if (keys.some(key => source[key] === "" || !Number.isFinite(Number(source[key])))) {
    Toast("error", "输入参数不全或格式不正确", 3);
    return;
  }
  toricLoading.value = true;
  toricError.value = "";
  try {
    const response = await fetch("https://visionhealthmed.com/api-eye/toric-iol/calculate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        k1Flat: Number(source.k1), k1FlatAxis: Number(source.k1Axis),
        k2Steep: Number(source.k2), k2SteepAxis: Number(source.k2Axis),
        siaCyl: Number(source.siaCyl), siaAxis: Number(source.siaAxis),
        iolDist: Number(source.iolDist), iolCyl: Number(source.iolCyl),
        totalCorneal: source.totalCorneal,
      }),
    });
    if (!response.ok) throw new Error(`网络请求失败，状态码：${response.status}`);
    Object.keys(toricResult).forEach(key => delete toricResult[key]);
    Object.assign(toricResult, await response.json());
  } catch (error) {
    toricError.value = error.message || "请求失败";
  } finally {
    toricLoading.value = false;
  }
};

const handlePageClick = (e) => {
  if (e.srcElement.dataset.select === undefined) {
    showSelectList.value = false;
  }
}

const handleSelectMode = (mode) => {
  selectMode.value = mode;
  showSelectList.value = false;
  router.replace({ path: route.path, query: { ...route.query, mode } });
  if (mode === "3") {
    Object.keys(toricResult).forEach(key => delete toricResult[key]);
    handleToricCalculate();
  }
}

const formState = reactive({
  name: "",
  age: "",
  id: "",
  Surgeon: "",
  refractiveIndex: "1.3375",
  odal: "",
  odwtw: "",
  odcct: "",
  odlt: "",
  odaConstant: "",
  odtarget: "0",
  odacd: "",
  odk2: "",
  odk1: "",
  osal: "",
  oswtw: "",
  oscct: "",
  oslt: "",
  osaConstant: "",
  ostarget: "0",
  osacd: "",
  osk2: "",
  osk1: "",
  odk1Axis: "180",
  odk2Axis: "90",
  odsiaCyl: "0.40",
  odsiaAxis: "180",
  odiolDist: "4.0",
  odiolCyl: "3.00",
  odiolSphere: "-1.25",
  odtotalCorneal: false,
  osk1Axis: "180",
  osk2Axis: "90",
  ossiaCyl: "0.40",
  ossiaAxis: "180",
  osiolDist: "4.0",
  osiolCyl: "3.00",
  osiolSphere: "-1.25",
  ostotalCorneal: false,
});

const rules = {
  odal: [{ required: true, message: "", trigger: "blur" }],
  odk1: [{ required: true, message: "", trigger: "blur" }],
  odk2: [{ required: true, message: "", trigger: "blur" }],
  odacd: [{ required: true, message: "", trigger: "blur" }],
  odtarget: [{ required: true, message: "", trigger: "blur" }],
  odaConstant: [{ required: true, message: "", trigger: "blur" }],
  osal: [{ required: true, message: "", trigger: "blur" }],
  osk1: [{ required: true, message: "", trigger: "blur" }],
  osk2: [{ required: true, message: "", trigger: "blur" }],
  osacd: [{ required: true, message: "", trigger: "blur" }],
  ostarget: [{ required: true, message: "", trigger: "blur" }],
  osaConstant: [{ required: true, message: "", trigger: "blur" }],
};

const handleCalculate = () => {
  const testNumber = (value) => {
    return /^-?\d+(\.\d+)?$/.test(value);
  };
  Object.keys(formState).forEach((key) => {
    if (formState[key] && typeof formState[key] !== "boolean" && !testNumber(formState[key])) {
      if (key === "name" || key === "age" || key === "id" || key === "Surgeon") {
        return;
      }
      formState[key] = "";
    }
  });

  const odParams = selectMode.value === "3" ? {
    k1Flat: formState.odk1,
    k1FlatAxis: formState.odk1Axis,
    k2Steep: formState.odk2,
    k2SteepAxis: formState.odk2Axis,
    siaCyl: formState.odsiaCyl,
    siaAxis: formState.odsiaAxis,
    iolDist: formState.odiolDist,
    iolCyl: formState.odiolCyl,
    iolSphere: formState.odiolSphere,
    totalCorneal: formState.odtotalCorneal,
  } : [formState.refractiveIndex, formState.odal, formState.odk1, formState.odk2, formState.odacd, formState.odtarget, formState.odaConstant];
  const osParams = selectMode.value === "3" ? {
    k1Flat: formState.osk1,
    k1FlatAxis: formState.osk1Axis,
    k2Steep: formState.osk2,
    k2SteepAxis: formState.osk2Axis,
    siaCyl: formState.ossiaCyl,
    siaAxis: formState.ossiaAxis,
    iolDist: formState.osiolDist,
    iolCyl: formState.osiolCyl,
    iolSphere: formState.osiolSphere,
    totalCorneal: formState.ostotalCorneal,
  } : [formState.refractiveIndex, formState.osal, formState.osk1, formState.osk2, formState.osacd, formState.ostarget, formState.osaConstant];

  const paramsValid = (params) => Object.entries(params).every(([key, value]) => key === "totalCorneal" || value !== "");
  const odParamsValid = paramsValid(odParams);
  const osParamsValid = paramsValid(osParams);

  if (!odParamsValid && !osParamsValid) {
    Toast(
      "error",
      "输入参数不全, 请检查必填的输入参数( invalid input, check your input please )",
      3
    );
    return;
  }

  router.push({
    path: "/iolresult",
    query: {
      calc: JSON.stringify({
        od: { valid: odParamsValid, params: odParams },
        os: { valid: osParamsValid, params: osParams },
        mode: selectMode.value,
        userInfo: {
          name: formState.name,
          age: formState.age,
          id: formState.id,
          Surgeon: formState.Surgeon,
        },
      }),
    },
  });
};

const handleResetData = () => {
  if (selectMode.value === "3") {
    Object.assign(activeToric.value, {
      k1: "42.00", k1Axis: "180", k2: "44.00", k2Axis: "90",
      siaCyl: "0.40", siaAxis: "180", iolDist: "4.0", iolCyl: "3.00",
      sphere: "-1.25", totalCorneal: false,
    });
    Object.keys(toricResult).forEach(key => delete toricResult[key]);
    handleToricCalculate();
    return;
  }
  Object.keys(formState).forEach((key) => {
    formState[key] = "";
  });
  formState.refractiveIndex = "1.3375";
  formState.odtarget = "0";
  formState.ostarget = "0";
  Object.assign(formState, {
    odk1Axis: "180", odk2Axis: "90", odsiaCyl: "0.40", odsiaAxis: "180", odiolDist: "4.0", odiolCyl: "3.00", odiolSphere: "-1.25", odtotalCorneal: false,
    osk1Axis: "180", osk2Axis: "90", ossiaCyl: "0.40", ossiaAxis: "180", osiolDist: "4.0", osiolCyl: "3.00", osiolSphere: "-1.25", ostotalCorneal: false,
  });
};

watch(
  () => route,
  (val) => {
    if (val.path === "/calculate" && val.query.type === "new") {
      handleResetData();
    }
    if (val.path === "/calculate" && val.query.mode) {
      selectMode.value = String(val.query.mode);
      if (selectMode.value === "3") handleToricCalculate();
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

watch(toricEye, () => {
  Object.keys(toricResult).forEach(key => delete toricResult[key]);
  handleToricCalculate();
});

let toricTimer;
watch(activeToric, () => {
  if (selectMode.value !== "3") return;
  clearTimeout(toricTimer);
  toricTimer = setTimeout(handleToricCalculate, 300);
}, { deep: true });
</script>

<style lang="less" scoped>
.toric-page {
  max-width: 940px;
  margin: 20px auto;
  color: #333;
}

.toric-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 22px;
  color: #fff;
  border-radius: 10px 10px 0 0;
  background: linear-gradient(135deg, #35b7ad 10%, #abdcff);

  h2 { margin: 0; color: #fff; font-size: 20px; }
  p { margin: 4px 0 0; font-size: 12px; opacity: .9; }
  p em { margin-left: 12px; color: #f5222d; font-style: normal; font-weight: 700; opacity: 1; }
  > span { padding: 3px 12px; border-radius: 16px; background: rgba(255, 255, 255, .2); font-size: 11px; }
}

.toric-patient {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
  padding: 12px 16px;
  background: #f6fbfb;
  border: 1px solid #d9eeee;

  label { display: flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 600; }
  .ant-input-affix-wrapper, .ant-input { width: 120px; }
  .ant-select { width: 90px; }
}

.toric-input-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  padding: 18px 0;
}

.toric-card, .toric-analysis {
  padding: 14px 16px;
  border: 1px solid #d9eeee;
  border-radius: 10px;
  background: #f8fcfc;
}

.card-title, .analysis-title, .rotation-title {
  margin-bottom: 12px;
  color: #333;
  font-size: 15px;
  font-weight: 700;

  .title-badge { margin-left: 8px; padding: 1px 10px; color: #5abebf; border: 1px solid #d9eeee; border-radius: 12px; background: #fff; font-size: 10px; font-weight: 400; }
}
.aca-title { display: flex; justify-content: space-between; align-items: center; }
.aca-title /deep/ .ant-checkbox-wrapper { font-size: 15px; font-weight: 400; }

.toric-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 9px;

  label { width: 38px; text-align: right; color: #666; font-size: 12px; }
  label.wide-label { width: 75px; }
}
.toric-number-field { position: relative; width: 105px; }
.toric-number-field > span { position: absolute; z-index: 2; top: 50%; right: 24px; color: rgba(0, 0, 0, .45); transform: translateY(-50%); pointer-events: none; }
.toric-number-field /deep/ .ant-input-number { width: 100%; background: #fffef7; }
.toric-number-field /deep/ .ant-input-number-input { padding-right: 34px; text-align: center; }
.toric-number-field /deep/ .ant-input-number-disabled { background: #f5f5f5; }
.optical-inputs .toric-number-field { min-width: 0; flex: 1; }

.toric-result-line, .pca-box {
  margin-top: 10px;
  padding: 7px 12px;
  text-align: center;
  border-left: 3px solid #5abebf;
  border-radius: 4px;
  background: #eaf8f7;
  font-size: 12px;

  strong { margin-right: 10px; color: #35a9a5; }
}

.toric-hint { color: #999; text-align: center; font-size: 11px; }
.pca-box strong { display: block; margin: 3px 0 0; color: #d48806; }
.pca-card { display: flex; flex-direction: column; justify-content: space-around; }
.pca-card .card-title { margin-bottom: 10px; text-align: center; font-size: 17px; }
.pca-card .toric-hint { margin-bottom: 10px; font-size: 13px; }
.pca-card .pca-box { margin-top: 0; font-size: 14px; line-height: 20px; }
.combined-card { display: flex; flex-direction: column; }
.combined-section + .combined-section { margin-top: 10px; padding-top: 10px; border-top: 1px dashed #d9eeee; }
.optical-inputs { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
.optical-inputs label { display: flex; align-items: center; gap: 6px; color: #666; font-size: 12px; }
.optical-inputs label > span { white-space: nowrap; }
.optical-inputs .ant-input-affix-wrapper { min-width: 0; background: #fffef7; }
.important-input { border-color: #f5222d; color: #f5222d; font-weight: 700; }

.toric-analysis { margin-bottom: 15px; }
.toric-analysis .analysis-title,
.toric-analysis .rotation-title { text-align: center; }
.iol-summary { display: flex; justify-content: center; align-items: center; gap: 56px; flex-wrap: wrap; margin-bottom: 20px;}
.iol-summary > label { display: flex; align-items: center; gap: 8px; font-size: 12px; }
.iol-summary .ant-input-affix-wrapper, .iol-summary .ant-input { width: 160px; }
.axis-thumb { display: flex; align-items: center; gap: 25px; color: #666; font-size: 13px; }
.axis-thumb strong { color: #1677ff; font-size: 18px; }
.axis-circle { position: relative; flex: 0 0 auto; width: 96px; height: 96px; border: 1px solid #cfe6e5; border-radius: 50%; background: #fff; box-shadow: 0 4px 12px rgba(36, 83, 120, .08); }
.axis-circle:before, .axis-circle:after { content: ""; position: absolute; background: #dce9f2; }
.axis-circle:before { left: 47px; top: 8px; width: 1px; height: 80px; }
.axis-circle:after { top: 47px; left: 8px; width: 80px; height: 1px; }
.axis-circle i { position: absolute; z-index: 2; left: 47px; top: 47px; width: 40px; height: 3px; transform-origin: left center; background: #1677ff; }
.axis-circle b { position: absolute; z-index: 3; left: 43px; top: 38px; color: #1677ff; font-size: 14px; }
.axis-degree { position: absolute; z-index: 4; color: #777; font-size: 10px; line-height: 1; white-space: nowrap; }
.axis-degree-top { left: 50%; top: -11px; transform: translateX(-50%); }
.axis-degree-current { left: 50%; top: 4px; transform: translateX(-50%); color: #1677ff; font-weight: 700; }
.axis-degree-left { left: -18px; top: 50%; transform: translateY(-50%); }
.axis-degree-right { right: -20px; top: 50%; transform: translateY(-50%); }
.axis-degree-bottom { left: 50%; bottom: -11px; transform: translateX(-50%); }
.residual-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin: 16px 0; }
.residual-grid > div { padding: 10px; text-align: center; border: 1px solid #d9eeee; border-radius: 6px; background: #fff; }
.residual-grid span, .residual-grid strong { display: block; }
.residual-grid span { color: #777; font-size: 11px; }
.residual-grid strong { margin-top: 5px; color: #35a9a5; font-size: 14px; }
.residual-grid strong.danger { color: #f5222d; }
.rotation-title { margin-top: 8px; }
.rotation-table { width: 72%; margin: 0 auto; }
.rotation-table /deep/ table { table-layout: fixed; }
.rotation-table /deep/ th,
.rotation-table /deep/ td { width: 33.333%; text-align: center; }
.rotation-table /deep/ td { font-size: 14px; }
.toric-analysis /deep/ .rotation-angle { color: #555; font-weight: 600; }
.toric-analysis /deep/ .rotation-level { display: inline-block; padding: 1px 5px; border-radius: 4px; font-size: 11px; line-height: 16px; font-style: normal; font-weight: 400; }
.toric-analysis /deep/ .rotation-rate { font-weight: 700; }
.toric-analysis /deep/ .rotation-ideal,
.toric-analysis /deep/ .rotation-slight { color: #1677ff; }
.toric-analysis /deep/ .rotation-level.rotation-ideal,
.toric-analysis /deep/ .rotation-level.rotation-slight { background: #e6f4ff; }
.toric-analysis /deep/ .rotation-warning { color: #fa8c16; }
.toric-analysis /deep/ .rotation-level.rotation-warning { background: #fff7e6; }
.toric-analysis /deep/ .rotation-severe { color: #ff4d4f; }
.toric-analysis /deep/ .rotation-level.rotation-severe { background: #fff1f0; }
.toric-error { padding: 10px; color: #f5222d; border: 1px solid #ffccc7; background: #fff2f0; }
.toric-actions { display: flex; justify-content: center; gap: 12px; margin: 16px 0; }

@media (min-width: 701px) {
  .toric-page {
    max-width: 1400px;
    margin: 9px auto 0;
    font-size: 12px;
  }

  .toric-heading {
    padding: 9px 18px;
    border-radius: 7px 7px 0 0;

    h2 { font-size: 17px; line-height: 22px; }
    p { margin-top: 2px; font-size: 11px; line-height: 15px; }
    > span { padding: 2px 10px; font-size: 10px; }
  }

  .toric-patient {
    flex-wrap: nowrap;
    gap: 14px;
    padding: 7px 13px;

    label { gap: 5px; font-size: 11px; white-space: nowrap; }
    .ant-input-affix-wrapper, .ant-input { width: 130px; height: 27px; font-size: 11px; }
    .ant-select { width: 85px; font-size: 11px; }
    /deep/ .ant-select-selector { height: 27px; }
    /deep/ .ant-select-selection-item { line-height: 25px; }
  }

  .toric-input-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 9px;
    padding: 9px 0;
  }

  .combined-section + .combined-section { margin-top: 6px; padding-top: 6px; }

  .toric-card, .toric-analysis {
    padding: 9px 11px;
    border-radius: 7px;
  }

  .card-title, .analysis-title, .rotation-title {
    margin-bottom: 7px;
    font-size: 13px;
    line-height: 18px;

    span { margin-left: 5px; padding: 0 6px; font-size: 9px; }
  }

  .toric-row {
    display: grid;
    grid-template-columns: 34px minmax(58px, 1fr) 34px minmax(58px, 1fr);
    gap: 5px;
    margin-bottom: 6px;

    label { width: auto; font-size: 11px; }
    label.wide-label { width: auto; line-height: 12px; }
    .ant-input-affix-wrapper { width: 100%; min-width: 0; height: 27px; padding: 0 6px; font-size: 11px; }
  }

  .toric-card /deep/ .ant-checkbox-wrapper { font-size: 11px; }
  .toric-card /deep/ .ant-checkbox-inner { width: 14px; height: 14px; }
  .toric-result-line, .pca-box { margin-top: 6px; padding: 4px 7px; font-size: 10px; line-height: 16px; }
  .toric-hint { font-size: 9px; line-height: 14px; }
  .pca-card .card-title,
  .pca-card .toric-hint { margin-bottom: 6px; }
  .pca-box strong { margin-top: 2px; }

  .toric-analysis { margin-bottom: 7px; }
  .iol-summary { justify-content: center; gap: clamp(28px, 4vw, 64px); flex-wrap: nowrap; }
  .iol-summary > label { gap: 5px; font-size: 11px; white-space: nowrap; }
  .iol-summary .ant-input-affix-wrapper, .iol-summary .ant-input { width: 155px; height: 27px; font-size: 11px; }
  .axis-thumb { gap: 16px; font-size: 12px; }
  .axis-thumb strong { font-size: 17px; }
  .axis-circle { width: 88px; height: 88px; }
  .axis-circle:before { left: 43px; top: 7px; height: 74px; }
  .axis-circle:after { top: 43px; left: 7px; width: 74px; }
  .axis-circle i { left: 43px; top: 43px; width: 37px; }
  .axis-circle b { left: 39px; top: 34px; font-size: 13px; }
  .residual-grid { gap: 8px; margin: 7px 0; }
  .residual-grid > div { padding: 6px; }
  .residual-grid span { font-size: 10px; line-height: 14px; }
  .residual-grid strong { margin-top: 2px; font-size: 12px; line-height: 16px; }
  .rotation-title { margin-top: 4px; }
  .toric-analysis /deep/ .ant-table { font-size: 10px; line-height: 14px; }
  .toric-analysis /deep/ .ant-table-small .ant-table-thead > tr > th,
  .toric-analysis /deep/ .ant-table-small .ant-table-tbody > tr > td { padding: 3px 7px; }
  .toric-error { padding: 6px; font-size: 11px; }
  .toric-actions { gap: 10px; margin: 7px 0; }
  .toric-actions /deep/ .ant-btn { height: 27px; padding: 0 12px; font-size: 11px; }
}

@media (max-width: 700px) {
  .toric-page { margin-top: 12px; }
  .toric-heading { padding: 14px; }
  .toric-heading h2 { font-size: 17px; }
  .toric-heading > span { display: none; }
  .toric-input-grid { grid-template-columns: 1fr; }
  .toric-row { flex-wrap: wrap; }
  .iol-summary { justify-content: center; gap: 24px; }
  .axis-thumb { margin-left: 0; width: 100%; justify-content: center; }
  .axis-circle { width: 82px; height: 82px; }
  .axis-circle:before { left: 40px; top: 7px; height: 68px; }
  .axis-circle:after { top: 40px; left: 7px; width: 68px; }
  .axis-circle i { left: 40px; top: 40px; width: 34px; }
  .axis-circle b { left: 36px; top: 31px; }
  .residual-grid { grid-template-columns: 1fr; }
}

.ant-layout-header {
  padding: 0 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 1px;
  display: flex;
  justify-content: space-between;
  background: linear-gradient(135deg, #35b7ad 10%, #abdcff);
  color: #fff;
  font-size: 15px;
  font-weight: 600;

  span {
    color: #f5222d;
    font-size: 12px;
    margin-left: 10px;
    font-weight: 500;
    background-color: rgb(255 255 255 / 30%);
    border-radius: 5px;
    padding: 5px;
  }

  .right {
    font-weight: 700;
    font-size: 15px;
    color: #5ABEBF;
    letter-spacing: 1px;
    cursor: pointer;
    position: relative;
    top: 0.33rem;
    width: 6rem;
    height: 0.9rem;
    background: #FFFFFF;
    border-radius: 0.1rem;
    line-height: 0.9rem;
    .select {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .select-icon {
      width: 0.46rem;
      height: 0.46rem;
      background: url('../../assets/img/tabbar/arrow.png');
      background-size: 100% 100%;
      margin-left: 6px;
    }

    .select-list {
      position: absolute;
      top: 0.95rem;
      width: 4.36rem;
      height: 0px;
      background: #fff;
      border-radius: 4px;
      font-size: 13px;
      color: #525252;
      line-height: 34px;
      text-align: center;
      box-shadow: 0 0 2px 0 #ccc;
      text-shadow: none;
      transition: all 0.15s ease-in-out;
      overflow: hidden;
      z-index: 99;

      .active {
        background: #F3F3F3;
      }
    }

    .show {
      height: 2.7rem;
    }

  }
}

.custom-form .ant-form-item {
  width: 100%;
  text-align: left;
  margin-top: 10px;
}

.custom-form .ant-divider-horizontal.ant-divider-with-text-left:before,
.custom-form .ant-divider-horizontal.ant-divider-with-text-left:after {
  top: 0%;
}

/deep/ .ant-form-item-explain,
.ant-form-item-extra {
  min-height: 0px;
}

.ant-form-inline .ant-form-item {
  display: inline-block;
  margin-right: 16px;
  margin-bottom: 10px;
}

.bo-wrapper {
  height: 100vh;
  overflow-y: scroll;
  padding-bottom: 50px;
}

.bo-wrapper-pc {
  .ant-layout-header {
    height: 0.42rem;
    line-height: 0.42rem;
    padding-left: 0.52rem;
    padding-right: 0.28rem;
    font-size: 0.17rem;

    span {
      font-weight: 400;
      font-size: 0.09rem;
      color: #ffffff;
      background: none;
    }

    .right {
      font-weight: 500;
      font-size: 0.08rem;
      color: #5ABEBF;
      cursor: pointer;
      position: absolute;
      left: 1.5rem;
      top: 0.08rem;
      width: 1.2rem;
      height: 0.27rem;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;
      line-height: 0.27rem;
      text-align: center;
      padding: 0 6px 0 16px;

      .select {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .select-icon {
        width: 0.15rem;
        height: 0.15rem;
        background: url('../../assets/img/tabbar/arrow.png');
        background-size: 100% 100%;
        margin-left: 0.06rem;
      }

      .select-list {
        position: absolute;
        top: 0.28rem;
        left: 0;
        width: 1.14rem;
        height: 0rem;
        background: #fff;
        border-radius: 0.03rem;
        font-size: 0.08rem;
        color: #525252;
        line-height: 0.29rem;
        text-align: center;
        box-shadow: 0 0 2px 0 #ccc;
        text-shadow: none;
        transition: all 0.15s ease-in-out;
        overflow: hidden;

        .active {
          background: #F3F3F3;
        }
      }

      .show {
        height: 0.87rem;
      }

    }


  }

  .params-wrapper {
    display: flex;
    padding: 0 1.88rem;
    justify-content: space-between;
    width: 100%;

    /deep/ .ant-form-item-label>label {
      font-size: 0.07rem;
    }

    /deep/ .ant-form-item {
      font-size: 0.07rem;
    }

    .params-space {
      margin-right: 0.74rem;
    }

    .eye {
      font-size: 0.13rem;
      color: #333333;
      line-height: 0.18rem;
      letter-spacing: 1px;
      font-weight: bold;
      margin-bottom: 0.16rem;

      span {
        font-weight: 400;
        font-size: 0.07rem;
        color: #333333;
        line-height: 0.1rem;
        letter-spacing: 1px;
      }
    }
  }

  .user-info {
    display: flex;
    justify-content: space-between;
    padding: 0 1.88rem;
    width: 100%;

    div {
      display: flex;
      letter-spacing: 1px;
      font-size: 0.07rem;
      align-items: center;
      margin-top: 0.12rem;

      ::v-deep input {
        text-align: center;
        border: none;
        border-bottom: 1px solid #999999;
        width: 0.75rem;
        font-size: 0.07rem;
      }

      ::v-deep .ant-input:focus {
        box-shadow: none;
      }
    }
  }

  .note {
    padding: 0 0.8rem;
    width: 100%;
    font-size: 0.07rem;
  }

  button {
    font-size: 0.07rem;
    height: 0.16rem;
  }
}
</style>
